import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { Extension } from "@tiptap/react";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    selectionDecoration: {
      disableSelectionDecoration: () => ReturnType;
      enableSelectionDecoration: () => ReturnType;
    };
  }
}

export const SelectionDecoration = Extension.create({
  name: "selectionDecoration",
  addStorage() {
    return {
      isDisabled: true,
    };
  },
  addCommands() {
    return {
      disableSelectionDecoration: () => () => {
        this.storage.isDisabled = true;
        return false;
      },
      enableSelectionDecoration: () => () => {
        this.storage.isDisabled = false;
        return true;
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("selection"),
        props: {
          decorations: (state) => {
            if (this.storage.isDisabled) {
              return null;
            }

            const { selection } = state;
            const { isFocused } = this.editor;

            if (isFocused) {
              return null;
            }

            // If selection is empty, render a vertical line at the cursor position
            if (selection.empty) {
              return DecorationSet.create(state.doc, [
                Decoration.widget(selection.from, () => {
                  const cursor = document.createElement("span");
                  cursor.className = "cursor";
                  return cursor;
                }),
              ]);
            }

            return DecorationSet.create(state.doc, [
              Decoration.inline(selection.from, selection.to, {
                class: "selection",
              }),
            ]);
          },
        },
      }),
    ];
  },
});
